const auth = {
  signIn: "Sign In",
  signOut: "Sign Out",
  email: "Email",
  password: "Password",
  forgotPassword: "Forgot password?",
  resetPassword: "Reset Password",
  resetSent: "Password reset link sent to your email",
  invalidCredentials: "Invalid email or password",
  sessionExpired: "Session expired — please sign in again",
  welcomeBack: "Welcome back",
  signInToCommand: "Sign in to Command Center",
  newPassword: "New Password",
  passwordUpdated: "Password updated successfully",
  otpCode: "One-time code",
  sendCode: "Send Code",
  verifyCode: "Verify Code",
  codeSent: "Code sent to your email",
  invalidCode: "Invalid code — try again",
  resendCode: "Resend code",
  or: "or",
  signInWithGoogle: "Sign in with Google",
  signInWithGithub: "Sign in with GitHub",
  signInWithFacebook: "Sign in with Facebook",
  signInWithMicrosoft: "Sign in with Microsoft",
  signInWithApple: "Sign in with Apple",
  signInWithLinkedIn: "Sign in with LinkedIn",
  continueWith: "or continue with",
  createAccount: "Create Account",
  registerSubtitle: "Register to Command Center",
  alreadyHaveAccount: "Already have an account? Sign in",
  displayName: "Full Name",
  displayNamePlaceholder: "Your name",
  profileSetup: "Profile Setup",
  completeRegistration: "Complete Registration",
  changeEmail: "Change email",
  unauthorized: "You are not authorized to access this system",
  inviteOnly: "Access is by invitation only",
  accountPending: "Your account is pending approval",
} as const;
export default auth;
